import { icon as addArticle } from './add-article.svg';
import { icon as addAttachment } from './add-attachment.svg';
import { icon as addEmoji } from './add-emoji.svg';
import { icon as addLinkedArticles } from './add-linked-articles.svg';
import { icon as addSavedReply } from './add-saved-reply.svg';
import { icon as addSignature } from './add-signature.svg';
import { icon as agentCh } from './agent-ch.svg';
import { icon as agentList } from './agent-list.svg';
import { icon as agent } from './agent.svg';
import { icon as alertIndicationOrangeLarge } from './alert-indication-orange-large.svg';
import { icon as alertIndicationOrange } from './alert-indication-orange.svg';
import { icon as alertIndication } from './alert-indication.svg';
import { icon as alertRoundFilled } from './alert-round-filled.svg';
import { icon as alertRoundHollow } from './alert-round-hollow.svg';
import { icon as alertRound } from './alert-round.svg';
import { icon as alertSquareRound } from './alert-square-round.svg';
import { icon as alertSquare } from './alert-square.svg';
import { icon as alert } from './alert.svg';
import { icon as allChannelsIcon } from './all-channels-icon.svg';
import { icon as allChats } from './all-chats.svg';
import { icon as allFilters } from './all-filters.svg';
import { icon as allOpenTickets } from './all-open-tickets.svg';
import { icon as allTickets } from './all-tickets.svg';
import { icon as americanExpress } from './american-express.svg';
import { icon as answersLogo } from './answers-logo.svg';
import { icon as apiCh } from './api-ch.svg';
import { icon as apiIcon } from './api-icon.svg';
import { icon as api } from './api.svg';
import { icon as applyMacro } from './apply-macro.svg';
import { icon as applyPolicy } from './apply-policy.svg';
import { icon as archive } from './archive.svg';
import { icon as aricleType } from './aricle-type.svg';
import { icon as arrowBreadcrumb } from './arrow-breadcrumb.svg';
import { icon as arrowNext } from './arrow-next.svg';
import { icon as arrowPrev } from './arrow-prev.svg';
import { icon as arrowRight } from './arrow-right.svg';
import { icon as articleDescription } from './article-description.svg';
import { icon as articleLargePreview } from './article-large-preview.svg';
import { icon as articleNotes } from './article-notes.svg';
import { icon as articlePreview } from './article-preview.svg';
import { icon as articleSummary } from './article-summary.svg';
import { icon as article } from './article.svg';
import { icon as articlesCh } from './articles-ch.svg';
import { icon as assignAction } from './assign-action.svg';
import { icon as attachment } from './attachment.svg';
import { icon as audioThin } from './audio-thin.svg';
import { icon as backArrowSmall } from './back-arrow-small.svg';
import { icon as backArrow } from './back-arrow.svg';
import { icon as bankTransfer } from './bank-transfer.svg';
import { icon as brandLabel } from './brand-label.svg';
import { icon as brush } from './brush.svg';
import { icon as bulb } from './bulb.svg';
import { icon as bulkActions } from './bulk-actions.svg';
import { icon as buttonDd } from './button-dd.svg';
import { icon as calendarTile } from './calendar-tile.svg';
import { icon as calendar } from './calendar.svg';
import { icon as callBack } from './call-back.svg';
import { icon as callBubbleDots } from './call-bubble-dots.svg';
import { icon as callError } from './call-error.svg';
import { icon as callTransfer } from './call-transfer.svg';
import { icon as callbackPhone } from './callback-phone.svg';
import { icon as callback } from './callback.svg';
import { icon as cardsView } from './cards-view.svg';
import { icon as catArticle } from './cat-article.svg';
import { icon as categoryBig } from './category-big.svg';
import { icon as categoryMultiLevel } from './category-multi-level.svg';
import { icon as categoryPageCreateArticle } from './category-page-create-article.svg';
import { icon as categoryPageCreateCategory } from './category-page-create-category.svg';
import { icon as categoryPageCreateFeatureRequest } from './category-page-create-feature-request.svg';
import { icon as categoryPageCreateKnownIssue } from './category-page-create-known-issue.svg';
import { icon as category } from './category.svg';
import { icon as changeSmall } from './change-small.svg';
import { icon as change } from './change.svg';
import { icon as chatChLarge } from './chat-ch-large.svg';
import { icon as chatCh } from './chat-ch.svg';
import { icon as chatEmoji } from './chat-emoji.svg';
import { icon as chatOrigin } from './chat-origin.svg';
import { icon as chatTransferredWidget } from './chat-transferred-widget.svg';
import { icon as chat } from './chat.svg';
import { icon as checkCircleHollow } from './check-circle-hollow.svg';
import { icon as checkCircleInverted } from './check-circle-inverted.svg';
import { icon as checkGreen } from './check-green.svg';
import { icon as checkInline } from './check-inline.svg';
import { icon as checkMark } from './check-mark.svg';
import { icon as checkOne } from './check-one.svg';
import { icon as checkThinGreen } from './check-thin-green.svg';
import { icon as checkThin } from './check-thin.svg';
import { icon as checkTwo } from './check-two.svg';
import { icon as checkbox } from './checkbox.svg';
import { icon as checkmarkIllustrated } from './checkmark-illustrated.svg';
import { icon as checkmarkInCircle } from './checkmark-in-circle.svg';
import { icon as chevronBoldDown } from './chevron-bold-down.svg';
import { icon as clockFullSmall } from './clock-full-small.svg';
import { icon as clockFull } from './clock-full.svg';
import { icon as clockSmall } from './clock-small.svg';
import { icon as clockTile } from './clock-tile.svg';
import { icon as clock } from './clock.svg';
import { icon as closePanelDefault } from './close-panel-default.svg';
import { icon as close } from './close.svg';
import { icon as closeX } from './close-x.svg';
import { icon as cloud } from './cloud.svg';
import { icon as codeInsert } from './code-insert.svg';
import { icon as completedChatBubble } from './completed-chat-bubble.svg';
import { icon as controlRoom } from './control-room.svg';
import { icon as copyContent } from './copy-content.svg';
import { icon as creationClock } from './creation-clock.svg';
import { icon as currency } from './currency.svg';
import { icon as customView } from './custom-view.svg';
import { icon as customerInfoPanel } from './customer-info-panel.svg';
import { icon as date } from './date.svg';
import { icon as date2 } from './date-2.svg';
import { icon as deleteAction } from './delete-action.svg';
import { icon as deleteSectionFull } from './delete-section-full.svg';
import { icon as deleteSection } from './delete-section.svg';
import { icon as deletedUser } from './deleted-user.svg';
import { icon as desktopView } from './desktop-view.svg';
import { icon as dialpad } from './dialpad.svg';
import { icon as digitInputIllustrated } from './digit-input-illustrated.svg';
import { icon as diners } from './diners.svg';
import { icon as directionArrowDown } from './direction-arrow-down.svg';
import { icon as discover } from './discover.svg';
import { icon as docFile } from './doc-file.svg';
import { icon as dot } from './dot.svg';
import { icon as dots } from './dots.svg';
import { icon as doubleEdgedArrow } from './double-edged-arrow.svg';
import { icon as download } from './download.svg';
import { icon as drag } from './drag.svg';
import { icon as dropBorder } from './drop-border.svg';
import { icon as dropDownToggle } from './drop-down-toggle.svg';
import { icon as dropSmall } from './drop-small.svg';
import { icon as drop } from './drop.svg';
import { icon as dropdown } from './dropdown.svg';
import { icon as dubbleArrow } from './dubble-arrow.svg';
import { icon as duplicateArticles } from './duplicate-articles.svg';
import { icon as editLabel } from './edit-label.svg';
import { icon as editTasks } from './edit-tasks.svg';
import { icon as ellipsisVertical } from './ellipsis-vertical.svg';
import { icon as ellipsis } from './ellipsis.svg';
import { icon as emailCh } from './email-ch.svg';
import { icon as emailTicket } from './email-ticket.svg';
import { icon as email } from './email.svg';
import { icon as emptyArticleListSearch } from './empty-article-list-search.svg';
import { icon as emptyArticleList } from './empty-article-list.svg';
import { icon as emptyBell } from './empty-bell.svg';
import { icon as emptyInsightsArticles } from './empty-insights-articles.svg';
import { icon as emptyInsightsGraph } from './empty-insights-graph.svg';
import { icon as emptyInsightsIssues } from './empty-insights-issues.svg';
import { icon as emptyInsightsSearch } from './empty-insights-search.svg';
import { icon as emptyInsightsVotes } from './empty-insights-votes.svg';
import { icon as emptyMacros } from './empty-macros.svg';
import { icon as emptyPaper } from './empty-paper.svg';
import { icon as emptyStar } from './empty-star.svg';
import { icon as endCall } from './end-call.svg';
import { icon as endSessionsAction } from './end-sessions-action.svg';
import { icon as envelope } from './envelope.svg';
import { icon as errorPage } from './error-page.svg';
import { icon as everyone } from './everyone.svg';
import { icon as externalServiceIllustrated } from './external-service-illustrated.svg';
import { icon as eye } from './eye.svg';
import { icon as facebookCh } from './facebook-ch.svg';
import { icon as facebook } from './facebook.svg';
import { icon as fb } from './fb.svg';
import { icon as featureRequestType } from './feature-request-type.svg';
import { icon as filtersToggle } from './filters-toggle.svg';
import { icon as flag } from './flag.svg';
import { icon as fullStar } from './full-star.svg';
import { icon as globe } from './globe.svg';
import { icon as globusGrey } from './globus-grey.svg';
import { icon as globusSmall } from './globus-small.svg';
import { icon as globusTiny } from './globus-tiny.svg';
import { icon as globus } from './globus.svg';
import { icon as greenCheckmark } from './green-checkmark.svg';
import { icon as greenDot } from './green-dot.svg';
import { icon as groupAvatar } from './group-avatar.svg';
import { icon as groupList } from './group-list.svg';
import { icon as hangupIllustrated } from './hangup-illustrated.svg';
import { icon as hangupThin } from './hangup-thin.svg';
import { icon as hash } from './hash.svg';
import { icon as helpcenterCh } from './helpcenter-ch.svg';
import { icon as highPriorityOi } from './high-priority-oi.svg';
import { icon as highPriority } from './high-priority.svg';
import { icon as homeIconBig } from './home-icon-big.svg';
import { icon as homeIcon } from './home-icon.svg';
import { icon as homePage } from './home-page.svg';
import { icon as hourglass } from './hourglass.svg';
import { icon as image } from './image.svg';
import { icon as inbound } from './inbound.svg';
import { icon as infoMessage } from './info-message.svg';
import { icon as info } from './info.svg';
import { icon as infoFull } from './info-full.svg';
import { icon as insightsIcon } from './insights-icon.svg';
import { icon as instagramCh } from './instagram-ch.svg';
import { icon as integrationsIcon } from './integrations-icon.svg';
import { icon as ivr } from './ivr.svg';
import { icon as jcb } from './jcb.svg';
import { icon as key } from './key.svg';
import { icon as knownIssueType } from './known-issue-type.svg';
import { icon as labelChannel } from './label-channel.svg';
import { icon as labelGroup } from './label-group.svg';
import { icon as labelLanguage } from './label-language.svg';
import { icon as labelQueues } from './label-queues.svg';
import { icon as label } from './label.svg';
import { icon as language } from './language.svg';
import { icon as lightningSmall } from './lightning-small.svg';
import { icon as lightningVertical } from './lightning-vertical.svg';
import { icon as lightning } from './lightning.svg';
import { icon as listView } from './list-view.svg';
import { icon as lockGrey } from './lock-grey.svg';
import { icon as lockM } from './lock-m.svg';
import { icon as lockPage } from './lock-page.svg';
import { icon as lockWhite } from './lock-white.svg';
import { icon as lock } from './lock.svg';
import { icon as lowPriorityOi } from './low-priority-oi.svg';
import { icon as lowPriority } from './low-priority.svg';
import { icon as maAssign } from './ma-assign.svg';
import { icon as maAssigned } from './ma-assigned.svg';
import { icon as maDelete } from './ma-delete.svg';
import { icon as maFlag } from './ma-flag.svg';
import { icon as maPriority } from './ma-priority.svg';
import { icon as maReply } from './ma-reply.svg';
import { icon as maStatus } from './ma-status.svg';
import { icon as manageSmall } from './manage-small.svg';
import { icon as markNotSpam } from './mark-not-spam.svg';
import { icon as markSpam } from './mark-spam.svg';
import { icon as masterCard } from './master-card.svg';
import { icon as maximize } from './maximize.svg';
import { icon as mediumThinX } from './medium-thin-x.svg';
import { icon as mediumX } from './medium-x.svg';
import { icon as meltingIceCream } from './melting-ice-cream.svg';
import { icon as menuAppCredits } from './menu-app-credits.svg';
import { icon as menuArticles } from './menu-articles.svg';
import { icon as menuCallCenter } from './menu-call-center.svg';
import { icon as menuControlRoom } from './menu-control-room.svg';
import { icon as menuCrm } from './menu-crm.svg';
import { icon as menuHome } from './menu-home.svg';
import { icon as menuInsights } from './menu-insights.svg';
import { icon as menuInviteTeam } from './menu-invite-team.svg';
import { icon as menuOnboarding } from './menu-onboarding.svg';
import { icon as menuSettings } from './menu-settings.svg';
import { icon as menuSpotter } from './menu-spotter.svg';
import { icon as menuTeamMembers } from './menu-team-members.svg';
import { icon as menuTickets } from './menu-tickets.svg';
import { icon as menuViewLive } from './menu-view-live.svg';
import { icon as mergeAction } from './merge-action.svg';
import { icon as minimize } from './minimize.svg';
import { icon as missedChat } from './missed-chat.svg';
import { icon as mobileView } from './mobile-view.svg';
import { icon as moveTo } from './move-to.svg';
import { icon as multiLevelField } from './multi-level-field.svg';
import { icon as multiLine } from './multi-line.svg';
import { icon as multipleGroup } from './multiple-group.svg';
import { icon as newChat } from './new-chat.svg';
import { icon as newListView } from './new-list-view.svg';
import { icon as noArticleResults } from './no-article-results.svg';
import { icon as noArticles } from './no-articles.svg';
import { icon as noAvatar } from './no-avatar.svg';
import { icon as noCategories } from './no-categories.svg';
import { icon as noCreditsIllustrated } from './no-credits-illustrated.svg';
import { icon as noDrop } from './no-drop.svg';
import { icon as noFieldsAdmin } from './no-fields-admin.svg';
import { icon as noFieldsAgent } from './no-fields-agent.svg';
import { icon as noTechData } from './no-tech-data.svg';
import { icon as noTicketResults } from './no-ticket-results.svg';
import { icon as noTicket } from './no-ticket.svg';
import { icon as noTickets } from './no-tickets.svg';
import { icon as normalPriorityOi } from './normal-priority-oi.svg';
import { icon as normalPriority } from './normal-priority.svg';
import { icon as nothingSelected } from './nothing-selected.svg';
import { icon as notificationCheck } from './notification-check.svg';
import { icon as numberInputIllustrated } from './number-input-illustrated.svg';
import { icon as numberInputThin } from './number-input-thin.svg';
import { icon as olive } from './olive.svg';
import { icon as oneInboxFullWidth } from './one-inbox-full-width.svg';
import { icon as openAssignedToMe } from './open-assigned-to-me.svg';
import { icon as outbound } from './outbound.svg';
import { icon as pauseFilled } from './pause-filled.svg';
import { icon as pauseMedium } from './pause-medium.svg';
import { icon as pauseRound } from './pause-round.svg';
import { icon as pause } from './pause.svg';
import { icon as pdfFileSmall } from './pdf-file-small.svg';
import { icon as pdfFile } from './pdf-file.svg';
import { icon as pencile } from './pencile.svg';
import { icon as percentageArrow } from './percentage-arrow.svg';
import { icon as percentageNoChange } from './percentage-no-change.svg';
import { icon as phoneCh } from './phone-ch.svg';
import { icon as phoneDots } from './phone-dots.svg';
import { icon as phoneError } from './phone-error.svg';
import { icon as playFilled } from './play-filled.svg';
import { icon as play } from './play.svg';
import { icon as plusChat } from './plus-chat.svg';
import { icon as plusWithBgBold } from './plus-with-bg-bold.svg';
import { icon as plusWithBgLarge } from './plus-with-bg-large.svg';
import { icon as plusWithBgSmall } from './plus-with-bg-small.svg';
import { icon as plusWithBg } from './plus-with-bg.svg';
import { icon as plusWithDisabledBgSmall } from './plus-with-disabled-bg-small.svg';
import { icon as plus } from './plus.svg';
import { icon as ppBackArrow } from './pp-back-arrow.svg';
import { icon as ppFailureFrame } from './pp-failure-frame.svg';
import { icon as ppSuccessFrame } from './pp-success-frame.svg';
import { icon as premiumCrown } from './premium-crown.svg';
import { icon as previewArticle } from './preview-article.svg';
import { icon as preview } from './preview.svg';
import { icon as priorityAction } from './priority-action.svg';
import { icon as priorityHigh } from './priority-high.svg';
import { icon as priorityLow } from './priority-low.svg';
import { icon as priorityNormal } from './priority-normal.svg';
import { icon as priority } from './priority.svg';
import { icon as publish } from './publish.svg';
import { icon as queuesEmptyState } from './queues-empty-state.svg';
import { icon as redDot } from './red-dot.svg';
import { icon as refreshCircleHollow } from './refresh-circle-hollow.svg';
import { icon as refreshGrey } from './refresh-grey.svg';
import { icon as refreshThin } from './refresh-thin.svg';
import { icon as refreshWithBg } from './refresh-with-bg.svg';
import { icon as refresh } from './refresh.svg';
import { icon as relatedArticle } from './related-article.svg';
import { icon as relevance } from './relevance.svg';
import { icon as remove } from './remove.svg';
import { icon as repliedByMe } from './replied-by-me.svg';
import { icon as replyAction } from './reply-action.svg';
import { icon as replyIcon } from './reply-icon.svg';
import { icon as replyIndicatorLarge } from './reply-indicator-large.svg';
import { icon as replyIndicator } from './reply-indicator.svg';
import { icon as reply } from './reply.svg';
import { icon as resolveIndicatorLarge } from './resolve-indicator-large.svg';
import { icon as resolveIndicator } from './resolve-indicator.svg';
import { icon as rocket } from './rocket.svg';
import { icon as roundMediumAlert } from './round-medium-alert.svg';
import { icon as routeCallIllustrated } from './route-call-illustrated.svg';
import { icon as routeThin } from './route-thin.svg';
import { icon as search } from './search.svg';
import { icon as securePayment } from './secure-payment.svg';
import { icon as sendChat } from './send-chat.svg';
import { icon as sendInputThin } from './send-input-thin.svg';
import { icon as setChannel } from './set-channel.svg';
import { icon as setGroup } from './set-group.svg';
import { icon as setQueue } from './set-queue.svg';
import { icon as setWorkload } from './set-workload.svg';
import { icon as sideBySide } from './side-by-side.svg';
import { icon as singleLine } from './single-line.svg';
import { icon as skillAvatar } from './skill-avatar.svg';
import { icon as sleepingChatBubble } from './sleeping-chat-bubble.svg';
import { icon as smallArrow } from './small-arrow.svg';
import { icon as smallCollapsibleToggle } from './small-collapsible-toggle.svg';
import { icon as smsChLarge } from './sms-ch-large.svg';
import { icon as smsCh } from './sms-ch.svg';
import { icon as snoozeAction } from './snooze-action.svg';
import { icon as snoozeNotification } from './snooze-notification.svg';
import { icon as snoozeSmall } from './snooze-small.svg';
import { icon as soundOff } from './sound-off.svg';
import { icon as soundOn } from './sound-on.svg';
import { icon as spam } from './spam.svg';
import { icon as splitView } from './split-view.svg';
import { icon as spotterProfile } from './spotter-profile.svg';
import { icon as statsIcon } from './stats-icon.svg';
import { icon as statusAction } from './status-action.svg';
import { icon as stock } from './stock.svg';
import { icon as stopwatch } from './stopwatch.svg';
import { icon as subcategoryArticleIcon } from './subcategory-article-icon.svg';
import { icon as subcategory } from './subcategory.svg';
import { icon as subfolder } from './subfolder.svg';
import { icon as supportIcon } from './support-icon.svg';
import { icon as switchButton } from './switch-button.svg';
import { icon as tabActive } from './tab-active.svg';
import { icon as tabCompleted } from './tab-completed.svg';
import { icon as tabWaiting } from './tab-waiting.svg';
import { icon as table } from './table.svg';
import { icon as teamMembers } from './team-members.svg';
import { icon as textToSpeechRound } from './text-to-speech-round.svg';
import { icon as textToSpeech } from './text-to-speech.svg';
import { icon as text } from './text.svg';
import { icon as thickSearch } from './thick-search.svg';
import { icon as thinArrowDown } from './thin-arrow-down.svg';
import { icon as thinArrowUp } from './thin-arrow-up.svg';
import { icon as ticketIcon } from './ticket-icon.svg';
import { icon as ticketOriginFacebook } from './ticket-origin-facebook.svg';
import { icon as ticketOriginInstagram } from './ticket-origin-instagram.svg';
import { icon as ticketOriginTwitter } from './ticket-origin-twitter.svg';
import { icon as tinyX } from './tiny-x.svg';
import { icon as transferCall } from './transfer-call.svg';
import { icon as transferThin } from './transfer-thin.svg';
import { icon as translate } from './translate.svg';
import { icon as trialCalendar } from './trial-calendar.svg';
import { icon as trianlgeCircled } from './trianlge-circled.svg';
import { icon as twitterCh } from './twitter-ch.svg';
import { icon as unionPay } from './union-pay.svg';
import { icon as unlinkArticle } from './unlink-article.svg';
import { icon as uploadIcon } from './upload-icon.svg';
import { icon as upload } from './upload.svg';
import { icon as upperArrowRight } from './upper-arrow-right.svg';
import { icon as url } from './url.svg';
import { icon as userNotes } from './user-notes.svg';
import { icon as viewsAllTickets } from './views-all-tickets.svg';
import { icon as viewsDefault } from './views-default.svg';
import { icon as viewsMyTickets } from './views-my-tickets.svg';
import { icon as viewsPrivate } from './views-private.svg';
import { icon as viewsSnooze } from './views-snooze.svg';
import { icon as viewsSpam } from './views-spam.svg';
import { icon as viewsTaken } from './views-taken.svg';
import { icon as viewsUnassigned } from './views-unassigned.svg';
import { icon as visa } from './visa.svg';
import { icon as visibility } from './visibility.svg';
import { icon as voicemailBubble } from './voicemail-bubble.svg';
import { icon as voicemailIlustrated } from './voicemail-ilustrated.svg';
import { icon as voicemailRed } from './voicemail-red.svg';
import { icon as voicemailStats } from './voicemail-stats.svg';
import { icon as voicemail } from './voicemail.svg';
import { icon as wand } from './wand.svg';
import { icon as warningInfo } from './warning-info.svg';
import { icon as welcomeBox } from './welcome-box.svg';
import { icon as whatsappCh } from './whatsapp-ch.svg';
import { icon as whatsapp } from './whatsapp.svg';
import { icon as widgetBook } from './widget-book.svg';
import { icon as widgetCh } from './widget-ch.svg';
import { icon as widgetChat } from './widget-chat.svg';
import { icon as widgetCompass } from './widget-compass.svg';
import { icon as widgetPhone } from './widget-phone.svg';
import { icon as widgetPositionLeft } from './widget-position-left.svg';
import { icon as widgetPositionRight } from './widget-position-right.svg';
import { icon as widgetQuestionMark } from './widget-question-mark.svg';
import { icon as widgetThemeEdgy } from './widget-theme-edgy.svg';
import { icon as widget } from './widget.svg';
import { icon as widgetsIcon } from './widgets-icon.svg';
import { icon as wireTransfer } from './wire-transfer.svg';
import { icon as xAlertMedium } from './x-alert-medium.svg';
import { icon as xCircleBold } from './x-circle-bold.svg';
import { icon as xCircleHollow } from './x-circle-hollow.svg';
import { icon as xCircleInverted } from './x-circle-inverted.svg';
import { icon as xCircle } from './x-circle.svg';
import { icon as xIllustrated } from './x-illustrated.svg';
import { icon as xlsFile } from './xls-file.svg';
export var iconsMap = {
    addArticle: addArticle,
    addAttachment: addAttachment,
    addEmoji: addEmoji,
    addLinkedArticles: addLinkedArticles,
    addSavedReply: addSavedReply,
    addSignature: addSignature,
    agentCh: agentCh,
    agentList: agentList,
    agent: agent,
    alertIndicationOrangeLarge: alertIndicationOrangeLarge,
    alertIndicationOrange: alertIndicationOrange,
    alertIndication: alertIndication,
    alertRoundFilled: alertRoundFilled,
    alertRoundHollow: alertRoundHollow,
    alertRound: alertRound,
    alertSquareRound: alertSquareRound,
    alertSquare: alertSquare,
    alert: alert,
    allChannelsIcon: allChannelsIcon,
    allChats: allChats,
    allFilters: allFilters,
    allOpenTickets: allOpenTickets,
    allTickets: allTickets,
    americanExpress: americanExpress,
    answersLogo: answersLogo,
    apiCh: apiCh,
    apiIcon: apiIcon,
    api: api,
    applyMacro: applyMacro,
    applyPolicy: applyPolicy,
    archive: archive,
    aricleType: aricleType,
    arrowBreadcrumb: arrowBreadcrumb,
    arrowNext: arrowNext,
    arrowPrev: arrowPrev,
    arrowRight: arrowRight,
    articleDescription: articleDescription,
    articleLargePreview: articleLargePreview,
    articleNotes: articleNotes,
    articlePreview: articlePreview,
    articleSummary: articleSummary,
    article: article,
    articlesCh: articlesCh,
    assignAction: assignAction,
    attachment: attachment,
    audioThin: audioThin,
    backArrowSmall: backArrowSmall,
    backArrow: backArrow,
    bankTransfer: bankTransfer,
    brandLabel: brandLabel,
    brush: brush,
    bulb: bulb,
    bulkActions: bulkActions,
    buttonDd: buttonDd,
    calendarTile: calendarTile,
    calendar: calendar,
    callBack: callBack,
    callBubbleDots: callBubbleDots,
    callError: callError,
    callTransfer: callTransfer,
    callbackPhone: callbackPhone,
    callback: callback,
    cardsView: cardsView,
    catArticle: catArticle,
    categoryBig: categoryBig,
    categoryMultiLevel: categoryMultiLevel,
    categoryPageCreateArticle: categoryPageCreateArticle,
    categoryPageCreateCategory: categoryPageCreateCategory,
    categoryPageCreateFeatureRequest: categoryPageCreateFeatureRequest,
    categoryPageCreateKnownIssue: categoryPageCreateKnownIssue,
    category: category,
    changeSmall: changeSmall,
    change: change,
    chatChLarge: chatChLarge,
    chatCh: chatCh,
    chatEmoji: chatEmoji,
    chatOrigin: chatOrigin,
    chatTransferredWidget: chatTransferredWidget,
    chat: chat,
    checkCircleHollow: checkCircleHollow,
    checkCircleInverted: checkCircleInverted,
    checkGreen: checkGreen,
    checkInline: checkInline,
    checkMark: checkMark,
    checkOne: checkOne,
    checkThinGreen: checkThinGreen,
    checkThin: checkThin,
    checkTwo: checkTwo,
    checkbox: checkbox,
    checkmarkIllustrated: checkmarkIllustrated,
    checkmarkInCircle: checkmarkInCircle,
    chevronBoldDown: chevronBoldDown,
    clockFullSmall: clockFullSmall,
    clockFull: clockFull,
    clockSmall: clockSmall,
    clockTile: clockTile,
    clock: clock,
    closePanelDefault: closePanelDefault,
    close: close,
    closeX: closeX,
    cloud: cloud,
    codeInsert: codeInsert,
    completedChatBubble: completedChatBubble,
    controlRoom: controlRoom,
    copyContent: copyContent,
    creationClock: creationClock,
    currency: currency,
    customView: customView,
    customerInfoPanel: customerInfoPanel,
    date: date,
    date2: date2,
    deleteAction: deleteAction,
    deleteSectionFull: deleteSectionFull,
    deleteSection: deleteSection,
    deletedUser: deletedUser,
    desktopView: desktopView,
    dialpad: dialpad,
    digitInputIllustrated: digitInputIllustrated,
    diners: diners,
    directionArrowDown: directionArrowDown,
    discover: discover,
    docFile: docFile,
    dot: dot,
    dots: dots,
    doubleEdgedArrow: doubleEdgedArrow,
    download: download,
    drag: drag,
    dropBorder: dropBorder,
    dropDownToggle: dropDownToggle,
    dropSmall: dropSmall,
    drop: drop,
    dropdown: dropdown,
    dubbleArrow: dubbleArrow,
    duplicateArticles: duplicateArticles,
    editLabel: editLabel,
    editTasks: editTasks,
    ellipsisVertical: ellipsisVertical,
    ellipsis: ellipsis,
    emailCh: emailCh,
    emailTicket: emailTicket,
    email: email,
    emptyArticleListSearch: emptyArticleListSearch,
    emptyArticleList: emptyArticleList,
    emptyBell: emptyBell,
    emptyInsightsArticles: emptyInsightsArticles,
    emptyInsightsGraph: emptyInsightsGraph,
    emptyInsightsIssues: emptyInsightsIssues,
    emptyInsightsSearch: emptyInsightsSearch,
    emptyInsightsVotes: emptyInsightsVotes,
    emptyMacros: emptyMacros,
    emptyPaper: emptyPaper,
    emptyStar: emptyStar,
    endCall: endCall,
    endSessionsAction: endSessionsAction,
    envelope: envelope,
    errorPage: errorPage,
    everyone: everyone,
    externalServiceIllustrated: externalServiceIllustrated,
    eye: eye,
    facebookCh: facebookCh,
    facebook: facebook,
    fb: fb,
    featureRequestType: featureRequestType,
    filtersToggle: filtersToggle,
    flag: flag,
    fullStar: fullStar,
    globe: globe,
    globusGrey: globusGrey,
    globusSmall: globusSmall,
    globusTiny: globusTiny,
    globus: globus,
    greenCheckmark: greenCheckmark,
    greenDot: greenDot,
    groupAvatar: groupAvatar,
    groupList: groupList,
    hangupIllustrated: hangupIllustrated,
    hangupThin: hangupThin,
    hash: hash,
    helpcenterCh: helpcenterCh,
    highPriorityOi: highPriorityOi,
    highPriority: highPriority,
    homeIconBig: homeIconBig,
    homeIcon: homeIcon,
    homePage: homePage,
    hourglass: hourglass,
    image: image,
    inbound: inbound,
    infoMessage: infoMessage,
    info: info,
    infoFull: infoFull,
    insightsIcon: insightsIcon,
    instagramCh: instagramCh,
    integrationsIcon: integrationsIcon,
    ivr: ivr,
    jcb: jcb,
    key: key,
    knownIssueType: knownIssueType,
    labelChannel: labelChannel,
    labelGroup: labelGroup,
    labelLanguage: labelLanguage,
    labelQueues: labelQueues,
    label: label,
    language: language,
    lightningSmall: lightningSmall,
    lightningVertical: lightningVertical,
    lightning: lightning,
    listView: listView,
    lockGrey: lockGrey,
    lockM: lockM,
    lockPage: lockPage,
    lockWhite: lockWhite,
    lock: lock,
    lowPriorityOi: lowPriorityOi,
    lowPriority: lowPriority,
    maAssign: maAssign,
    maAssigned: maAssigned,
    maDelete: maDelete,
    maFlag: maFlag,
    maPriority: maPriority,
    maReply: maReply,
    maStatus: maStatus,
    manageSmall: manageSmall,
    markNotSpam: markNotSpam,
    markSpam: markSpam,
    masterCard: masterCard,
    maximize: maximize,
    mediumThinX: mediumThinX,
    mediumX: mediumX,
    meltingIceCream: meltingIceCream,
    menuAppCredits: menuAppCredits,
    menuArticles: menuArticles,
    menuCallCenter: menuCallCenter,
    menuControlRoom: menuControlRoom,
    menuCrm: menuCrm,
    menuHome: menuHome,
    menuInsights: menuInsights,
    menuInviteTeam: menuInviteTeam,
    menuOnboarding: menuOnboarding,
    menuSettings: menuSettings,
    menuSpotter: menuSpotter,
    menuTeamMembers: menuTeamMembers,
    menuTickets: menuTickets,
    menuViewLive: menuViewLive,
    mergeAction: mergeAction,
    minimize: minimize,
    missedChat: missedChat,
    mobileView: mobileView,
    moveTo: moveTo,
    multiLevelField: multiLevelField,
    multiLine: multiLine,
    multipleGroup: multipleGroup,
    newChat: newChat,
    newListView: newListView,
    noArticleResults: noArticleResults,
    noArticles: noArticles,
    noAvatar: noAvatar,
    noCategories: noCategories,
    noCreditsIllustrated: noCreditsIllustrated,
    noDrop: noDrop,
    noFieldsAdmin: noFieldsAdmin,
    noFieldsAgent: noFieldsAgent,
    noTechData: noTechData,
    noTicketResults: noTicketResults,
    noTicket: noTicket,
    noTickets: noTickets,
    normalPriorityOi: normalPriorityOi,
    normalPriority: normalPriority,
    nothingSelected: nothingSelected,
    notificationCheck: notificationCheck,
    numberInputIllustrated: numberInputIllustrated,
    numberInputThin: numberInputThin,
    olive: olive,
    oneInboxFullWidth: oneInboxFullWidth,
    openAssignedToMe: openAssignedToMe,
    outbound: outbound,
    pauseFilled: pauseFilled,
    pauseMedium: pauseMedium,
    pauseRound: pauseRound,
    pause: pause,
    pdfFileSmall: pdfFileSmall,
    pdfFile: pdfFile,
    pencile: pencile,
    percentageArrow: percentageArrow,
    percentageNoChange: percentageNoChange,
    phoneCh: phoneCh,
    phoneDots: phoneDots,
    phoneError: phoneError,
    playFilled: playFilled,
    play: play,
    plusChat: plusChat,
    plusWithBgBold: plusWithBgBold,
    plusWithBgLarge: plusWithBgLarge,
    plusWithBgSmall: plusWithBgSmall,
    plusWithBg: plusWithBg,
    plusWithDisabledBgSmall: plusWithDisabledBgSmall,
    plus: plus,
    ppBackArrow: ppBackArrow,
    ppFailureFrame: ppFailureFrame,
    ppSuccessFrame: ppSuccessFrame,
    premiumCrown: premiumCrown,
    previewArticle: previewArticle,
    preview: preview,
    priorityAction: priorityAction,
    priorityHigh: priorityHigh,
    priorityLow: priorityLow,
    priorityNormal: priorityNormal,
    priority: priority,
    publish: publish,
    queuesEmptyState: queuesEmptyState,
    redDot: redDot,
    refreshCircleHollow: refreshCircleHollow,
    refreshGrey: refreshGrey,
    refreshThin: refreshThin,
    refreshWithBg: refreshWithBg,
    refresh: refresh,
    relatedArticle: relatedArticle,
    relevance: relevance,
    remove: remove,
    repliedByMe: repliedByMe,
    replyAction: replyAction,
    replyIcon: replyIcon,
    replyIndicatorLarge: replyIndicatorLarge,
    replyIndicator: replyIndicator,
    reply: reply,
    resolveIndicatorLarge: resolveIndicatorLarge,
    resolveIndicator: resolveIndicator,
    rocket: rocket,
    roundMediumAlert: roundMediumAlert,
    routeCallIllustrated: routeCallIllustrated,
    routeThin: routeThin,
    search: search,
    securePayment: securePayment,
    sendChat: sendChat,
    sendInputThin: sendInputThin,
    setChannel: setChannel,
    setGroup: setGroup,
    setQueue: setQueue,
    setWorkload: setWorkload,
    sideBySide: sideBySide,
    singleLine: singleLine,
    skillAvatar: skillAvatar,
    sleepingChatBubble: sleepingChatBubble,
    smallArrow: smallArrow,
    smallCollapsibleToggle: smallCollapsibleToggle,
    smsChLarge: smsChLarge,
    smsCh: smsCh,
    snoozeAction: snoozeAction,
    snoozeNotification: snoozeNotification,
    snoozeSmall: snoozeSmall,
    soundOff: soundOff,
    soundOn: soundOn,
    spam: spam,
    splitView: splitView,
    spotterProfile: spotterProfile,
    statsIcon: statsIcon,
    statusAction: statusAction,
    stock: stock,
    stopwatch: stopwatch,
    subcategoryArticleIcon: subcategoryArticleIcon,
    subcategory: subcategory,
    subfolder: subfolder,
    supportIcon: supportIcon,
    switchButton: switchButton,
    tabActive: tabActive,
    tabCompleted: tabCompleted,
    tabWaiting: tabWaiting,
    table: table,
    teamMembers: teamMembers,
    textToSpeechRound: textToSpeechRound,
    textToSpeech: textToSpeech,
    text: text,
    thickSearch: thickSearch,
    thinArrowDown: thinArrowDown,
    thinArrowUp: thinArrowUp,
    ticketIcon: ticketIcon,
    ticketOriginFacebook: ticketOriginFacebook,
    ticketOriginInstagram: ticketOriginInstagram,
    ticketOriginTwitter: ticketOriginTwitter,
    tinyX: tinyX,
    transferCall: transferCall,
    transferThin: transferThin,
    translate: translate,
    trialCalendar: trialCalendar,
    trianlgeCircled: trianlgeCircled,
    twitterCh: twitterCh,
    unionPay: unionPay,
    unlinkArticle: unlinkArticle,
    uploadIcon: uploadIcon,
    upload: upload,
    upperArrowRight: upperArrowRight,
    url: url,
    userNotes: userNotes,
    viewsAllTickets: viewsAllTickets,
    viewsDefault: viewsDefault,
    viewsMyTickets: viewsMyTickets,
    viewsPrivate: viewsPrivate,
    viewsSnooze: viewsSnooze,
    viewsSpam: viewsSpam,
    viewsTaken: viewsTaken,
    viewsUnassigned: viewsUnassigned,
    visa: visa,
    visibility: visibility,
    voicemailBubble: voicemailBubble,
    voicemailIlustrated: voicemailIlustrated,
    voicemailRed: voicemailRed,
    voicemailStats: voicemailStats,
    voicemail: voicemail,
    wand: wand,
    warningInfo: warningInfo,
    welcomeBox: welcomeBox,
    whatsappCh: whatsappCh,
    whatsapp: whatsapp,
    widgetBook: widgetBook,
    widgetCh: widgetCh,
    widgetChat: widgetChat,
    widgetCompass: widgetCompass,
    widgetPhone: widgetPhone,
    widgetPositionLeft: widgetPositionLeft,
    widgetPositionRight: widgetPositionRight,
    widgetQuestionMark: widgetQuestionMark,
    widgetThemeEdgy: widgetThemeEdgy,
    widget: widget,
    widgetsIcon: widgetsIcon,
    wireTransfer: wireTransfer,
    xAlertMedium: xAlertMedium,
    xCircleBold: xCircleBold,
    xCircleHollow: xCircleHollow,
    xCircleInverted: xCircleInverted,
    xCircle: xCircle,
    xIllustrated: xIllustrated,
    xlsFile: xlsFile
};
export { addArticle, addAttachment, addEmoji, addLinkedArticles, addSavedReply, addSignature, agentCh, agentList, agent, alertIndicationOrangeLarge, alertIndicationOrange, alertIndication, alertRoundFilled, alertRoundHollow, alertRound, alertSquareRound, alertSquare, alert, allChannelsIcon, allChats, allFilters, allOpenTickets, allTickets, americanExpress, answersLogo, apiCh, apiIcon, api, applyMacro, applyPolicy, archive, aricleType, arrowBreadcrumb, arrowNext, arrowPrev, arrowRight, articleDescription, articleLargePreview, articleNotes, articlePreview, articleSummary, article, articlesCh, assignAction, attachment, audioThin, backArrowSmall, backArrow, bankTransfer, brandLabel, brush, bulb, bulkActions, buttonDd, calendarTile, calendar, callBack, callBubbleDots, callError, callTransfer, callbackPhone, callback, cardsView, catArticle, categoryBig, categoryMultiLevel, categoryPageCreateArticle, categoryPageCreateCategory, categoryPageCreateFeatureRequest, categoryPageCreateKnownIssue, category, changeSmall, change, chatChLarge, chatCh, chatEmoji, chatOrigin, chatTransferredWidget, chat, checkCircleHollow, checkCircleInverted, checkGreen, checkInline, checkMark, checkOne, checkThinGreen, checkThin, checkTwo, checkbox, checkmarkIllustrated, checkmarkInCircle, chevronBoldDown, clockFullSmall, clockFull, clockSmall, clockTile, clock, closePanelDefault, close, closeX, cloud, codeInsert, completedChatBubble, controlRoom, copyContent, creationClock, currency, customView, customerInfoPanel, date, date2, deleteAction, deleteSectionFull, deleteSection, deletedUser, desktopView, dialpad, digitInputIllustrated, diners, directionArrowDown, discover, docFile, dot, dots, doubleEdgedArrow, download, drag, dropBorder, dropDownToggle, dropSmall, drop, dropdown, dubbleArrow, duplicateArticles, editLabel, editTasks, ellipsisVertical, ellipsis, emailCh, emailTicket, email, emptyArticleListSearch, emptyArticleList, emptyBell, emptyInsightsArticles, emptyInsightsGraph, emptyInsightsIssues, emptyInsightsSearch, emptyInsightsVotes, emptyMacros, emptyPaper, emptyStar, endCall, endSessionsAction, envelope, errorPage, everyone, externalServiceIllustrated, eye, facebookCh, facebook, fb, featureRequestType, filtersToggle, flag, fullStar, globe, globusGrey, globusSmall, globusTiny, globus, greenCheckmark, greenDot, groupAvatar, groupList, hangupIllustrated, hangupThin, hash, helpcenterCh, highPriorityOi, highPriority, homeIconBig, homeIcon, homePage, hourglass, image, inbound, infoMessage, info, infoFull, insightsIcon, instagramCh, integrationsIcon, ivr, jcb, key, knownIssueType, labelChannel, labelGroup, labelLanguage, labelQueues, label, language, lightningSmall, lightningVertical, lightning, listView, lockGrey, lockM, lockPage, lockWhite, lock, lowPriorityOi, lowPriority, maAssign, maAssigned, maDelete, maFlag, maPriority, maReply, maStatus, manageSmall, markNotSpam, markSpam, masterCard, maximize, mediumThinX, mediumX, meltingIceCream, menuAppCredits, menuArticles, menuCallCenter, menuControlRoom, menuCrm, menuHome, menuInsights, menuInviteTeam, menuOnboarding, menuSettings, menuSpotter, menuTeamMembers, menuTickets, menuViewLive, mergeAction, minimize, missedChat, mobileView, moveTo, multiLevelField, multiLine, multipleGroup, newChat, newListView, noArticleResults, noArticles, noAvatar, noCategories, noCreditsIllustrated, noDrop, noFieldsAdmin, noFieldsAgent, noTechData, noTicketResults, noTicket, noTickets, normalPriorityOi, normalPriority, nothingSelected, notificationCheck, numberInputIllustrated, numberInputThin, olive, oneInboxFullWidth, openAssignedToMe, outbound, pauseFilled, pauseMedium, pauseRound, pause, pdfFileSmall, pdfFile, pencile, percentageArrow, percentageNoChange, phoneCh, phoneDots, phoneError, playFilled, play, plusChat, plusWithBgBold, plusWithBgLarge, plusWithBgSmall, plusWithBg, plusWithDisabledBgSmall, plus, ppBackArrow, ppFailureFrame, ppSuccessFrame, premiumCrown, previewArticle, preview, priorityAction, priorityHigh, priorityLow, priorityNormal, priority, publish, queuesEmptyState, redDot, refreshCircleHollow, refreshGrey, refreshThin, refreshWithBg, refresh, relatedArticle, relevance, remove, repliedByMe, replyAction, replyIcon, replyIndicatorLarge, replyIndicator, reply, resolveIndicatorLarge, resolveIndicator, rocket, roundMediumAlert, routeCallIllustrated, routeThin, search, securePayment, sendChat, sendInputThin, setChannel, setGroup, setQueue, setWorkload, sideBySide, singleLine, skillAvatar, sleepingChatBubble, smallArrow, smallCollapsibleToggle, smsChLarge, smsCh, snoozeAction, snoozeNotification, snoozeSmall, soundOff, soundOn, spam, splitView, spotterProfile, statsIcon, statusAction, stock, stopwatch, subcategoryArticleIcon, subcategory, subfolder, supportIcon, switchButton, tabActive, tabCompleted, tabWaiting, table, teamMembers, textToSpeechRound, textToSpeech, text, thickSearch, thinArrowDown, thinArrowUp, ticketIcon, ticketOriginFacebook, ticketOriginInstagram, ticketOriginTwitter, tinyX, transferCall, transferThin, translate, trialCalendar, trianlgeCircled, twitterCh, unionPay, unlinkArticle, uploadIcon, upload, upperArrowRight, url, userNotes, viewsAllTickets, viewsDefault, viewsMyTickets, viewsPrivate, viewsSnooze, viewsSpam, viewsTaken, viewsUnassigned, visa, visibility, voicemailBubble, voicemailIlustrated, voicemailRed, voicemailStats, voicemail, wand, warningInfo, welcomeBox, whatsappCh, whatsapp, widgetBook, widgetCh, widgetChat, widgetCompass, widgetPhone, widgetPositionLeft, widgetPositionRight, widgetQuestionMark, widgetThemeEdgy, widget, widgetsIcon, wireTransfer, xAlertMedium, xCircleBold, xCircleHollow, xCircleInverted, xCircle, xIllustrated, xlsFile };
//# sourceMappingURL=index.js.map